import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'

import uuid from 'uuid/v4'
import * as yup from 'yup'

export const checkOutFieldsSchema = yup.object().shape({
  pick_up_name: yup.string(),
  pick_up_contact_number: yup.string(),
  pick_up_relationship: yup.string(),
})

export type CheckOutFieldsType = yup.InferType<typeof checkOutFieldsSchema>

export function getEmptyCheckoutFields(): CheckOutFieldsType {
  return {
    pick_up_name: '',
    pick_up_contact_number: '',
    pick_up_relationship: '',
  }
}

export default function validator(data: CheckOutFieldsType) {
  return getValidationResult(data, checkOutFieldsSchema)
}
